import { apiPrivateAxios } from "../../axios";
import { IGeocodePlace } from "./types";

export const geocodingRequest = {
  getGeocodePlaces: (value: string): Promise<IGeocodePlace[]> =>
    apiPrivateAxios.get(`/geocoding/geocode?searchQuery=${value}`),
};

export default { geocodingRequest };
